import PropTypes from "prop-types"
import classnames from "classnames"
import MissingAttendeeInfoError from "./MissingAttendeeInfoError"

const AttendeeEmergencyContact = ({ attendee }) => {
  const missingRequiredEmergencyContactClass = {
    "reg-details__item-incomplete":
      (attendee.isRequiredEmergencyContact && !attendee.emergencyContact) ||
      (attendee.isRequiredEmergencyContact &&
        (!attendee.emergencyContact.name || !attendee.emergencyContact.phoneNumber))
  }

  return (
    <>
      <div className="d-f ai-c">
        <dt className={`label ${classnames(missingRequiredEmergencyContactClass)}`}>
          Emergency contact
        </dt>
        <button
          className="xs-btn quiet-btn btn2 ml-1"
          data-modal-url={attendee.paths.editAttendeeEmergencyContact}
        >
          Edit
        </button>
      </div>
      <dd className="mb-1">
        {!attendee.emergencyContact ||
        (!attendee.emergencyContact.name && !attendee.emergencyContact.phoneNumber) ? (
          <MissingAttendeeInfoError
            errorString="Not provided"
            showErrorExplanation={attendee.isRequiredEmergencyContact}
          />
        ) : (
          <span>{attendee.emergencyContact.toS}</span>
        )}
      </dd>
    </>
  )
}

AttendeeEmergencyContact.propTypes = {
  attendee: PropTypes.shape({
    emergencyContact: PropTypes.shape({
      toS: PropTypes.string,
      name: PropTypes.string,
      phoneNumber: PropTypes.string
    }),
    isRequiredEmergencyContact: PropTypes.bool,
    paths: PropTypes.shape({
      editAttendeeEmergencyContact: PropTypes.string
    })
  })
}

export default AttendeeEmergencyContact
